import 'modernizr';
import 'lazysizes';
import Password from './components/password';
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
//import PhotoSwipeVideoPlugin from 'photoswipe/dist/photoswipe-video-plugin.esm.js';

document.addEventListener('DOMContentLoaded', () => {
  const data = '11001001';
  const redirectUrl = 'index.html';
  const passwordGate = new Password(data, redirectUrl);

  if (passwordGate.isOnPasswordGatePage()) {
    passwordGate.initPasswordGate('password', 'submit', 'error-message');
  } else {
    passwordGate.protectPage();
  }
});

if (document.querySelector('.js--photoswipe')) {
  document.querySelectorAll('.js--photoswipe').forEach(el => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: el,
      children: 'a',
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 'fit',
      maxZoomLevel: 1,
      imageClickAction: 'next',
      tapAction: 'next',

      paddingFn: viewportSize => ({
        top: viewportSize.x < 600 ? 0 : 80,
        bottom: viewportSize.x < 600 ? 0 : 80,
        left: viewportSize.x < 600 ? 0 : 80,
        right: viewportSize.x < 600 ? 0 : 80,
      }),

      allowPanToNext: false, // prevent swiping to the next slide when image is zoomed
      allowMouseDrag: true, // display dragging cursor at max zoom level
      wheelToZoom: false, // enable wheel-based zoom
      zoom: false, // disable default zoom button
      pswpModule: () => import('photoswipe'),
    });

    // const videoPlugin = new PhotoSwipeVideoPlugin(lightbox, {
    // options
    //});

    lightbox.init();
  });
}
